import { render, staticRenderFns } from "./DirectPlacementTable.vue?vue&type=template&id=ad20c194"
import script from "./DirectPlacementTable.vue?vue&type=script&lang=js"
export * from "./DirectPlacementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports